import { getIndorImageSrc, IndorImages } from "../../../../features"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { setSearchLineIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { store } from "../../../../stateManagement/store"
import { ContentHeaderButton } from "../../contentHeaderButton"

const searchLineButtonIconSrc = getIndorImageSrc(IndorImages.MapNavigateZoom);

export default function ContentHeaderSearchWidgets() {

    const searchLineIsShown = useAppSelector(state => state.contentHeader.searchLineIsShown)

    function controlSearchLineButton() {
        const searchLineIsShown = store.getState().contentHeader.searchLineIsShown
        store.dispatch(setSearchLineIsShown(!searchLineIsShown))
    }

    const widgetsConfigArray = [
        {
            active: searchLineIsShown,
            name: "Поиск",
            imageSrc: searchLineButtonIconSrc,
            onClick: controlSearchLineButton
        }
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                        />
                    )
                }
            })}
        </>
    )
}